<script setup>
import LoadingSpinner from '@/components/Spinners/LoadingSpinner.vue'
import BaseModal from '@/components/Alerts/BaseModal.vue'

defineProps({
	message: { type: String, default: 'Loading...' }
})

</script>

<template>
	<BaseModal :show="true">
		<LoadingSpinner />
		<span class="mt-4">{{ message }}</span>
	</BaseModal>
</template>

<style scoped>

</style>